// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_bNJ","cls2":"PodcastLibraryCarouselAd-cls2_aWd PodcastLibraryCarouselAd-cls1_bNJ"};